import { render, staticRenderFns } from "./navBuddy.vue?vue&type=template&id=38f9bf42"
import script from "./navBuddy.vue?vue&type=script&lang=js"
export * from "./navBuddy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports